import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  TextField,
  Modal,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ReplyIcon from '@mui/icons-material/Reply';
import "react-quill-new/dist/quill.snow.css"; // Import Quill styles
import ReactQuill from "react-quill-new"; // Import React Quill


const ProviderInspireAnnouncements = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [posts, setPosts] = useState([
    { id: 1, title: 'How to integrate APIs in React?', description: 'I am new to React and need help with API integration.' },
    { id: 2, title: 'Best practices for state management?', description: 'Should I use Redux or Context API for state management?' },
  ]);

  const modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }], // Header levels
        ["bold", "italic", "underline", "strike"], // Text styles
        [{ color: [] }, { background: [] }], // Text and background color
        [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
        [{ list: "ordered" }, { list: "bullet" }], // Lists
        [{ indent: "-1" }, { indent: "+1" }], // Indent
        [{ direction: "rtl" }], // Text direction
        ["blockquote", "code-block"], // Block elements
        [{ align: [] }], // Alignment
        ["link", "image", "video"], // Media
        ["clean"], // Remove formatting
    ],
};

  
  const [content, setContent] = useState("");
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  const handlePost = () => {
    const newPost = {
      id: posts.length + 1,
      title,
      description,
    };
    setPosts([newPost, ...posts]);
    setTitle('');
    setDescription('');
    setOpen(false);
  };

  const handleViewDetails = (post) => {
    navigate(`/post/${post.id}`, { state: { post } });
  };

  return (
    <Box sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Top Bar */}
      <AppBar position="static" sx={{ backgroundColor: '#2196f3' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Community Forum=====
          </Typography>
          <Button color="inherit" onClick={() => setOpen(true)}>
            Create New Post
          </Button>
        </Toolbar>
      </AppBar>

      {/* Post List */}
      <Box sx={{ maxWidth: '1200px', margin: '20px auto', padding: '10px' }}>
        {posts.map((post) => (
        <Card key={post.id} sx={{ marginBottom: '15px', width: '100%' }}>
            <CardContent>
            <Box
                sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                }}
            >
                <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {post.title}
                </Typography>
                <Typography variant="body2" sx={{ marginTop: '5px', color: '#555' }}>
                    {post.description}
                </Typography>
                </Box>
                <Button size="small" color="primary" onClick={() => handleViewDetails(post)}>
                <ReplyIcon />
                <RemoveRedEyeIcon />
                </Button>
            </Box>
            </CardContent>
        </Card>
        ))}
      
      </Box>

      {/* Modal for Creating Post */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            height:500,
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: '15px' }}>
            Create New Post
          </Typography>
          <TextField
            label="Title"
            variant="outlined"
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ marginBottom: '15px' }}
          />
       
          <ReactQuill
                value={content}
                onChange={setContent}
                placeholder="Start typing here..."
                style={{
                    marginBottom: "89px",
                    background: "#fff",
                    borderRadius: "5px",
                    height:"142px",
                    minHeight: "200px",
                    

                }}
                modules={modules} // Add the full toolbar
            />
          <Button variant="contained" fullWidth onClick={handlePost}>
            Post
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default ProviderInspireAnnouncements;

